import React from "react";
// ANT DESIGN COMPONENTS
import { Modal, Button, Tooltip, notification } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COPY TO CLIBBOARD
import { CopyToClipboard } from "react-copy-to-clipboard";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateOpenModalPsw } from "../../../redux/users/userSlice";
// INTERFACES
import { RootState } from "../../../app/store";

function UsersModalPsw({ userPsw }: any) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();
  const [t] = useTranslation("global");

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { openModalPsw } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const handleCloseModal = () => {
    dispatch(updateOpenModalPsw(false));
  };

  const onCopy = () => {
    notification.open({
      message: <span className="generalStyles__success">{t("general.copyToClipboard")}</span>,
      description: t("general.passwordCopiedToClipboard"),
      placement: "top",
      className: `monitoring__notification__${theme}`,
    });
  };
  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Modal
      onOk={handleCloseModal}
      closable={false}
      onCancel={handleCloseModal}
      open={openModalPsw}
      footer={null}
    >
      <div>
        <div className="text-center">
          <FontAwesomeIcon
            icon={faCircleCheck}
            className="generalStyles__success generalStyles__deleteItemIcon"
          />
          <p className="generalStyles__success">{t("general.success") || "Success"}</p>
          <p className="generalStyles__info">{t("general.offlinePassword")}</p>
          <div style={{ marginBottom: "12px" }}>
            <span className="generalStyles__bold">{userPsw}</span>
          </div>
          <div className="generalStyles__flexCenter">
            <CopyToClipboard onCopy={onCopy} text={userPsw}>
              <Tooltip title={t("general.copyToClipboard")}>
                <Button
                  className="buttonStyle__4"
                  icon={<FontAwesomeIcon icon={faCopy} className="generalStyles__mrFix" />}
                >
                  {t("general.copyToClipboard")}
                </Button>
              </Tooltip>
            </CopyToClipboard>
          </div>
          <div className="generalStyles__flexEnd mt-4">
            <div>
              <Button onClick={handleCloseModal} className="buttonStyle__4">
                {t("general.close")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default UsersModalPsw;
